import * as React from "react";
import type { SVGProps } from "react";
const Component = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 139 5" {...props}><rect xmlns="http://www.w3.org/2000/svg" width={139} height={5} fill="currentColor" rx={2.5} transform="matrix(-1 0 0 1 139 0)" /></svg>;
export default Component;